import { Component, effect, inject, signal } from '@angular/core';
import { ModalComponent } from '../modal/modal.component';
import { QrCodeComponent } from '../qr-code/qr-code.component';
import { ModalService } from '../../utils/services/modal.service';
import { BusinessService } from '../../services/business.service';
import { TranslocoModule } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'qwiko-payment-qrcode',
  imports: [ModalComponent, QrCodeComponent, TranslocoModule],
  templateUrl: './payment-qrcode.component.html',
  styleUrl: './payment-qrcode.component.scss',
})
export class PaymentQRCodeComponent {
  modalService = inject(ModalService);
  businessService = inject(BusinessService);

  paymentLinkEffect = effect(() => {
    if (this.businessService.business()?.code) {
      let link: string = '';
      link = `${environment.qrUrl}/?b=${this.businessService.business()?.code}`;
      this.link.set(link);

      // if (this.transactionCode()) {
      //   return `${environment.qrUrl}/?t=${this.transactionCode()}`;
      // }
      // if (this.selectedPaymentAccount()) {
      //   let link: string = '';
      //   if (this.isOffLineMode()) {
      //     return this.offlinePaymentLink();
      //   }

      //   link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}`;
      //   if (this.ussdAmount()) {
      //     link = `${environment.qrUrl}/?a=${this.selectedPaymentAccount()?.code}&am=${this.ussdAmount()}`;
      //   }
      //   return link;
      // } else if (this.businessService.business()?.code) {
      //   let link: string = '';
      //   if (this.isOffLineMode()) {
      //     return this.offlinePaymentLink();
      //   }
      //   link = `${environment.qrUrl}/?b=${this.businessService.business()?.code}`;
      //   if (this.ussdAmount()) {
      //     link = `${environment.qrUrl}/?b=${this.businessService.business()?.code}&am=${this.ussdAmount()}`;
      //   }
      //   return link;
      // } else {
      //   return null;
      // }
    }
  });
  link = signal<string>('');
}
